import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import FortisAuth from "./fortis/FortisAuth";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(<React.StrictMode><FortisAuth /></React.StrictMode>);
